module.exports = __webpack_public_path__ + "img/media_tem_1.ef3dec4d.png";